export default __webpack_public_path__ + "static/media/1x2.6c209085.svg";